import { v4 as uuidv4 } from 'uuid';

export default (worker, event, ...params) => {
    const hashID = uuidv4();
    return new Promise((resolve, reject) => {
        if (_.isUndefined(worker.loadedFonts)) {
            worker.loadedFonts = [];
        }
        worker.onmessage = ($event) => {
            if (_.get($event, 'data.method')) {
                const { method, result, hashID: _hashID } = $event.data;
                switch (method) {
                    case 'setFont': {
                        if (!worker.loadedFonts.includes(params[0])) {
                            console.error(
                                `TRYING TO SET CUSTOM FONT-FAMILY, THAT WASN'T LOADED: '${params[0]}'.`,
                                'CALL \'loadCustomFontAsync\' FUNCTION BEFORE!'
                            );
                        }
                        break;
                    }
                    case 'loadCustomFontAsync': {
                        if (!worker.loadedFonts.includes(params[0])) {
                            worker.loadedFonts.push(params[0]);
                        }
                        break;
                    }
                    default: break;
                }
                if (method === event && hashID === _hashID) {
                    resolve(result);
                }
            }
        };
        worker.postMessage({
            method: event,
            params,
            hashID
        });
    });
};
